import { Dimension } from "./dimension";
import { CodecMap, MetricName, CODEC_MAP } from "./codec-mapping";

export type Unit<Metric extends MetricName> = ReturnType<
  CodecMap[Metric]["toUnit"]
>;

export type Measurement = {
  metricName: MetricName;
  dimensions: Dimension[];
};

export function toDimensions<T extends MetricName>(
  metricName: T,
  value: Unit<T>
): Dimension[] {
  const codec = CODEC_MAP[metricName] as CodecMap[T];
  /* as never is a hack to circumvent a typing problem I was not able to solve */
  return codec.toDimensions(value as never);
}

export function toUnit<T extends MetricName>(
  metricName: T,
  dimensions: Dimension[]
) {
  const codec = CODEC_MAP[metricName] as CodecMap[T];
  return codec.toUnit(dimensions) as Unit<T>;
}
